import React, { useRef } from "react";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";

export default function MethodSlider({ methodData }) {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    cssEase: "ease",
  };

  const CustomArrows = () => (
    <>
      <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
          <Icons name="Longarrow_left" />
      </div>
      <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
          <Icons name="Longarrow_right" />
      </div>
    </>
    );

  return (
    <>
      <section className="turnkey-prohead">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <h4 className="heading center-heading">{methodData.heading}</h4>
            </div>
          </div>
        </div>
      </section>


      <section className="mastery-process">
        <div className="container">
          <div className="row">

            <div className="col-lg-12">
                <div className="mastery-slider">
                    <Slider {...settings} ref={sliderRef}>
                      {methodData.processSteps.map((step, index) => (
                        <div key={index}>
                          <div className="slideprocess-box">
                            <img src={step.left.img} loading="lazy" className={`img-responsive ${step.left.imgClass || ""}`} alt={step.left.title} />
                            <div>
                              <span>{step.left.count}</span>
                              <h4>{step.left.title}</h4>
                              <p>{step.left.desc}</p>
                            </div>
                          </div>

                          <div className="slideprocess-box slideprocess-right">
                            <img src={step.right.img} loading="lazy" className={`img-responsive ${step.right.imgClass || ""}`} alt={step.right.title} />
                            <div>
                              <span>{step.right.count}</span>
                              <h4>{step.right.title}</h4>
                              <p>{step.right.desc}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>

                    <CustomArrows />
                </div>
            </div>

          </div>
        </div>

        <div className="slideprocess-dott"></div>
      </section>
    </>
  );
}



